export function minDateTimeFun(maxData, plusMinutes) {
    //当前时间
    let currentTime = new Date()
    let year = currentTime.getFullYear()
    let month = currentTime.getMonth();
    let date = currentTime.getDate();
    let hours = currentTime.getHours();
    let minutes = currentTime.getMinutes();
    if (maxData === 'maxDate') {
        return new Date(year, month, date + 2, 23, 59)
    } else {
        //return new Date(year, month, date, hours + 1, minutes)
		if(plusMinutes == undefined || plusMinutes == null) {
			plusMinutes = 15;
		}
		var m = minutes + plusMinutes;
		var h = hours;
		//console.log('mh1', m, h);
		if(m > 59) {
			m = m - 60;
			h = h + 1;
		}
		console.log('mh2', m, h);
		return new Date(year, month, date, h, m)
    }

}

export function GetDateStr(AddDayCount) {
    let time = new Date();
    time.setDate(time.getDate() + AddDayCount);//获取AddDayCount天后的日期 
    let date = time.getDate();
    return date
}


export function formattingTime(formatting, time) {
    //当前时间
    let currentTime = new Date();
    let currentDate = currentTime.getDate();
    //传入的时间
    let year = time.getFullYear()

    let month = time.getMonth() + 1;
    let date = time.getDate();

    let hours = time.getHours();
    let minutes = time.getMinutes();
    var days = null
    if (currentDate === date) {
        days = '当天'
    } else if (GetDateStr(1) === date) {
        days = '明天'
    } else if (GetDateStr(2) === date) {
        days = '后天'
    } else {
        days = date
    }
    if (minutes < 10) {
        minutes = '0' + minutes
    }
    if (formatting === 'day:MM:dd') {
        let timeObj = {
            year: year,
            month: month,
            dataText: days,
            days: date,
            hours: hours,
            minutes: minutes
        }
        return timeObj
    }
    return `${year}/${month}/${date} ${hours}:${minutes}`
}

export function TimeSecond(second) {

    let setIntervalTime = setInterval(() => {
        second--
        if (second === 1) {
            clearInterval(setIntervalTime)
        }
    }, 1000);
    return setIntervalTime
}

//数组对象去重
export function RemoveDuplicates(obj) {
    if(obj.length==0||obj.length==null){        
        return
    }
    console.log('数组对象去重',obj)
  let Duplicates = obj.reduce((previousValue, currentValue) => {
        console.log('currentValue',currentValue)
       // Duplicates.push(currentValue)
       previousValue[currentValue.address] ? '' : previousValue[currentValue.address] = true && previousValue.push(currentValue);
    })
    return Duplicates
}

//截取url
export function splitUrl(name){
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let urlArray = window.location.search.substr(1).match(reg);
    return urlArray
}
